/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ net: NonNullable<unknown>, cargos: NonNullable<unknown>, orders: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown> }} Cargos_Sales_Range_SummaryInputs */

const en_cargos_sales_range_summary = /** @type {(inputs: Cargos_Sales_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.net} net bags sold across ${i?.cargos} cargos (${i?.orders} orders), ${i?.from} – ${i?.to}.`)
};

const es_cargos_sales_range_summary = /** @type {(inputs: Cargos_Sales_Range_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.net} sacos netos vendidos en ${i?.cargos} cargas (${i?.orders} pedidos), ${i?.from} – ${i?.to}.`)
};

/**
* | output |
* | --- |
* | "{net} net bags sold across {cargos} cargos ({orders} orders), {from} – {to}." |
*
* @param {Cargos_Sales_Range_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_summary = /** @type {((inputs: Cargos_Sales_Range_SummaryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_SummaryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_summary(inputs)
	return es_cargos_sales_range_summary(inputs)
});